import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PRODUCT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SpecimenRequisitionPage } from '@/features/productRequisition/pages/SpecimenRequisitionPage';
import { requisitionSheetSearchSchema } from '@/features/productRequisition/types/productRequisition.types';

export const Route = createFileRoute('/_auth/product/specimen-requisition')({
  beforeLoad: () => requirePermission(PRODUCT_PERMISSIONS.SPECIMEN_REQUISITION_VIEW),
  validateSearch: requisitionSheetSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Specimen Requisition">
      <Suspense fallback={<PageLoader />}>
        <SpecimenRequisitionPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
